export const MaintenanceContractsPermissions = {
  ViewandsearchinPropertyManagementMaintenanceContracts: {
    permissionsId: '987001df-99f3-4ad2-c9d1-08d94f66fc61',
    permissionsName: 'View and search in  Property Management Maintenance Contracts',
    componentsId: null,
    components: null,
  },

  CreateMaintenanceContract: {
    components: null,
    componentsId: null,
    permissionsId: 'd0694fd2-c653-4af1-932c-08d967db92be',
    permissionsName: 'Create Maintenance Contract'
  },
  ViewPortfolio: {
    components: null,
    componentsId: null,
    permissionsId: '626dfbd4-eeb5-485d-932d-08d967db92be',
    permissionsName: 'View Portfolio'
  },
  UpdateMaintenanceContract:
  {
    permissionsId: 'f3a393bb-3a6c-4670-0d71-08d96c602a6b',
    permissionsName: 'Update Maintenance Contract',
    componentsId: null,
    components: null
  },
  DeleteMaintenanceContract:
  {
    permissionsId: '8354f640-ac93-46b7-0d79-08d96c602a6b',
    permissionsName: 'Delete Maintenance Contract',
    componentsId: null,
    components: null
  }


};
